






















































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import {Direction, KtSetting} from "../interfaces";
import {State, Styles} from "../store";
import FiltersVue from "./FiltersVue.vue";
import {trans} from "../../plagins/translate";

@Component({
    components: {FiltersVue}
})
export default class SettingsVue extends Vue {

    direction_list: Direction[] = [Direction.asc, Direction.desc];

    getDirectionName(direction: Direction) {
        return direction === Direction.asc ? 'Ascending' : 'Descending'
    }

    state: State | any;
    styles: Styles | any = {};

    valueComparator(a: KtSetting, b: KtSetting) {
        return a.id === b.id;
    }

    // selected_item: number | any = 0;

    selectSortColumn(item: KtSetting) {
        this.$store.commit('set_sort_by', item)
    }

    selectDirection(item: Direction) {
        this.$store.commit('set_direction_for_sort', item)
    }

    setPaginatorLimit(limit: number) {
        this.$store.commit('set_paginator_limit', limit)
    }

    trans(s: string): string {
        return trans(s);
    }

    mounted(): void {

    }

    created(): void {
        this.state = this.$store.state;
        this.styles = this.$store.state.remote_data.styles;
    }

}
